import React, { Component } from "react";
import { connect } from "react-redux";
import Info from "../shared/Info";
import StaticModal from "../shared/StaticModal";
import {
  addMembers,
  selectAddMember,
} from "../../../state/ducks/loyalty/index";
import $ from "jquery";
import Inputmask from "inputmask";
import { getKvkkMetni } from "../../../services/common.service";


function referansGiris() {
  var ad = $("#ad").val();
  var soyad = $("#soyad").val();
  var gsm = $("#tel").val();
  var aciklama = $("#aciklama").val();
  var durum = 1; // 1 herşey doğru

  // checkbox kontrol
  if ($("#onaychecked").is(':checked')) {
    $("#kvkk_hatamesaj").html("");
  } else {
    durum = 0; // Seçili değil
    $("#kvkk_hatamesaj").html("KVKK Taahhütnamesini onaylayınız");
  }

  // Ad
  if (ad == "") {
    durum = 0;
    $("#ad").parent().addClass("t-error");
    $("#ad").next().html("<i class='t-icon-error text-danger'></i>");
    $("#ad_hatamesaj").html("Ad alanı boş bırakılamaz");
  } else {
    $("#ad").parent().removeClass("t-error");
    $("#ad").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#ad_hatamesaj").html("");
  }
  // soyad
  if (soyad == "") {
    durum = 0;
    $("#soyad").parent().addClass("t-error");
    $("#soyad").next().html("<i class='t-icon-error text-danger'></i>");
    $("#soyad_hatamesaj").html("Soyad alanı boş bırakılamaz");
  } else {
    $("#soyad").parent().removeClass("t-error");
    $("#soyad").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#soyad_hatamesaj").html("");
  }
  // GSM boş mu kontrol
  if (gsm == "") {
    durum = 0; // Mesaj Boş
    $("#tel").parent().addClass("t-error");
    $("#tel").next().html("<i class='t-icon-error text-danger'></i>");
    $("#gsm_hatamesaj").html("GSM alanı boş bırakılamaz");
  } else {
    var regextel = /^5[0-9]{2}[0-9]{3}[0-9]{2}[0-9]{2}/.test(gsm.replace(/\D/g, ''));
    if (!regextel) {
      durum = 0; // Mesaj Boş
      $("#tel").parent().addClass("t-error");
      $("#tel").next().html("<i class='t-icon-error text-danger'></i>");
      $("#gsm_hatamesaj").html("GSM formatı kontrol edin.");
    }
    else {

      $("#tel").parent().removeClass("t-error");
      $("#tel").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#gsm_hatamesaj").html("");
    }
  };
  // Açıklama boş mu kontrol
  if (aciklama == "") {
    durum = 0; // Mesaj Boş
    $("#aciklama").parent().addClass("t-error");
    $("#aciklama").next().html("<i class='t-icon-error text-danger'></i>");
    $("#aciklama_hatamesaj").html("Açıklama alanı boş bırakılamaz");
  } else {
    $("#aciklama").parent().removeClass("t-error");
    $("#aciklama").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#aciklama_hatamesaj").html("");
  };
  return durum;

  
}
export class SubmitReference extends Component {
  state = {
    name: "",
    surName: "",
    phone: "",
    text: "",
    kvkkMetni: "",
  };
  

  componentDidMount() {
    this.maskAndRegexInput()
    this.getKvkk();
  }
  maskAndRegexInput() {
    var tel = document.getElementById("tel");

    if (tel != null) {
      Inputmask("(999) 999-99-99").mask(tel);
    }

  }
  addMembers = (event) => {
    event.preventDefault();

    if (referansGiris() === 1) {
      this.props.addMembers(
        this.state.name, 
        this.state.surName, 
        this.state.phone.replace(/\D/g, ''), 
        this.state.text,
        $("#onaychecked").is(':checked'),
        this.kvkkMetni
        );
    }
  };

   getKvkk() {
    getKvkkMetni().then(
      response => {
        this.setState({ kvkkMetni: response.data });
      },
      error => {}
    );
   }


  
  kvkkonayla = e => {
    e.preventDefault();
    $("#kvkk-modal").modal('show');
  };

  render() {
    const { loyalty } = this.props;
    if (loyalty?.addedMember) {
      return (
        <Info
          header={"Referansınız alınmıştır."}
          body={
            "Referansınız ile ilgili gelişmeleri refaranslarım menüsünden takip edebilirsiniz."
          }
        ></Info>
      );
    } else {
      return (
        <div className="container-fluid">
          {/* yesil Alan*/}
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 1 */}
              <div className="row no-gutters t-kutu t-mavicizgi">
                <div
                  className="col bosluk backbottom"
                  style={{
                    backgroundImage: 'url("/assets/img/backgrounds/back_bottom_mavi.jpg")'
                  }}
                >
                  {/* içerikler */}
                  {/* Başlık */}
                  <div className="row no-gutters pb-4">
                    <div clss="col-auto">
                      <i className="t-icon-user-plus  icon" />
                    </div>
                    <div className="col d-flex flex-column justify-content-center">
                      <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                        Referanslarım
                      </div>
                      <span className="altBaslik">Referans Girişi</span>
                    </div>
                  </div>
                  <div className="row no-gutters">
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Ad</span>
                    </div>
                    {/* Ad*/}
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-user1" />
                        </div>
                        <input

                          id="ad"
                          name="ad"
                          type="text"
                          placeholder="Ad"
                          maxLength="100"
                          value={this.state.name}
                          onChange={(e) => {
                            this.setState({ name: e.target.value });
                          }}
                        />
                        <div />
                      </div>
                    </div>
                    {/* Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="ad_hatamesaj"
                    />
                    {/* SOYAD */}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Soyad</span>
                    </div>
                    {/* Ad Soyad*/}
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-user1" />
                        </div>
                        <input
                          id="soyad"
                          name="soyad"
                          type="text"

                          placeholder="Soyad"
                          maxLength="100"
                          value={this.state.surName}
                          onChange={(e) => {
                            this.setState({ surName: e.target.value });
                          }} />
                        <div />
                      </div>
                    </div>
                    {/* Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="soyad_hatamesaj"
                    />
                    {/* GSM */}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">GSM</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-phone1" />
                        </div>

                        <input
                          id="tel"
                          name="tel"
                          type="text"
                          placeholder="Cep Telefon Numarası"
                          value={this.state.phone}
                          onChange={(e) => {
                            this.setState({ phone: e.target.value });
                          }}
                        />
                        <div />
                      </div>
                    </div>
                    {/* KONU Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="gsm_hatamesaj"
                    />
                    {/* Açıklama*/}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Açıklama</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-bubble1" />
                        </div>
                        <textarea

                          id="aciklama"
                          rows="4"
                          maxLength="1000"
                          value={this.state.text}
                          onChange={(e) => {
                            this.setState({ text: e.target.value });
                          }}

                        />
                        <div />
                      </div>
                    </div>
                    {/* Mesaj Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="aciklama_hatamesaj"
                    />

                    {/* checkbox */}
                    <div className="col-12 d-flex align-items-center pl-3 pt-1">
                      <input
                        type="checkbox"
                        className="t-kvkkcheckbox"
                        value=""
                        id="onaychecked"
                      />
                      <span
                        className="t-icAciklamaYazi"
                        style={{ paddingLeft: 10, position: "relative" }}
                      >
                        <a id="kvkk-onayla" href="#kvkk-onayla" onClick={this.kvkkonayla}>KVKK Taahhütnamesi</a>'ni <strong>ONAYLIYORUM</strong>
                      </span>
                    </div>
                    {/* Mesaj Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="kvkk_hatamesaj"
                    />

                    {/* Button */}
                    <div className="col-12 d-flex justify-content-center pb-3 pt-2">
                      <button className="t-icButonMavi" onClick={this.addMembers}>
                        <span>Referans Gönder</span>
                        <i className="t-icon-arrow-right2" />
                      </button>
                    </div>
                  </div>
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              </div>
              {/* KUTU 1 BİTTİ */}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <StaticModal></StaticModal>
          <div className="row" style={{ height: 30 }} />

          <div className="modal" id="kvkk-modal" tabIndex="-1" style={{backgroundColor: "rgba(0,0,0,0.5)"}}>
                        <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
                            {/* Bu kısım animasyon için Hareket eden kısım. */}
                            <div className="t-modalContentMailOrder" id="id-modalTipi" style={(window.innerWidth<=900)?{width:"89%"}: {width:"51%"}}>
                                <div
                                    className="t-modalMailOrder"
                                    id="id-modalGenel"
                                    style={{ backgroundColor: "rgb(255, 255, 255)" ,boxShadow:"3px 3px 3px #939191"}}
                                >
                                    <div className="container-fluid">
                                        {/* Header */}
                                        <div className="row t-modalHeaderMailOrder">
                                            <div
                                                className="col"
                                                id="id-modalHeader"
                                                style={{ color: "rgb(119, 119, 119)" }}
                                            >
                                                KVKK Taahhütnamesi
                                            </div>
                                            <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                                <i
                                                    className="t-icon-cross"
                                                    id="id-modalHeaderIcon"
                                                    style={{ color: "rgb(119, 119, 119)" }}
                                                />
                                            </div>
                                        </div>
                                        {/* Body */}
                                        <div className="row t-modalBodyMailOrder">
                                            <div
                                                className="col-12 "
                                                id="id-modalBody"
                                                style={{ color: "rgb(119, 119, 119)",fontSize:"12pt" }}
                                            >
                                                {this.state.kvkkMetni}
                                            </div>
                                        </div>
                                        {/* footer*/}
                                        <div className="row t-modalFooterMailOrder">
                                            <div
                                                className="col-12"
                                                id="id-modalFooter"
                                                style={{ color: "rgb(102, 102, 102)" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    loyalty: selectAddMember(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  addMembers: (name, surName, phone, text, kvkkIzni, kvkkMetni) => dispatch(addMembers(name, surName, phone, text, kvkkIzni, kvkkMetni)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitReference);
